import { FC } from "react";
import { Grid, Skeleton } from "@mui/material";
import { Card } from "@/components";
import { formatNumberWithSuffix } from "@/utils";

interface KpiCardsProps {
  totalPotentialSavings: number;
  opportunityCount: number;
  fullyClaimedCount: number;
  programCount: number;
  isLoading: boolean;
}

const KpiCards: FC<KpiCardsProps> = ({
  totalPotentialSavings,
  opportunityCount,
  fullyClaimedCount,
  programCount,
  isLoading,
}) => {
  const cards = [
    { title: "Total Potential Savings", value: `$${formatNumberWithSuffix(totalPotentialSavings)}` },
    { title: "Opportunities", value: String(opportunityCount) },
    { title: "Fully Claimed", value: String(fullyClaimedCount) },
    { title: "FTA Programs", value: String(programCount) },
  ];

  return (
    <Grid container spacing={2}>
      {cards.map((card) => (
        <Grid item xs={12} sm={6} md={3} key={card.title}>
          {isLoading ? (
            <Skeleton variant="rounded" height={96} />
          ) : (
            <Card
              variant="kpi"
              sx={{ minHeight: { xs: 84, md: 96 } }}
              title={card.title}
              subtitle={card.value}
            />
          )}
        </Grid>
      ))}
    </Grid>
  );
};

export default KpiCards;
